import * as Icons from "heroicons-react";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useProfitLossReportQuery } from "../../../services/reportsApi";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";

const ProfitLossReport = () => {
  const auth = signInUser();

  const [warehouse, setWarehouse] = useState("allWh");
  const [invoiceId, setInvoiceId] = useState("");

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId } = auth;
  const lang = useSelector((state) => state.languageReducer);
  const { data: lossProfitData } = useProfitLossReportQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
    invoiceId,
  });

  console.log("Profit Loss Report Data:", lossProfitData);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");

  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);
  // console.log("Customer Wise Sales Report Data:", lossProfitData);

  const handleExportCSV = () => {
    if (!lossProfitData || lossProfitData?.length === 0) {
      alert("No data available for export.");
      return;
    }
  
    const start = new Date(startDate).toLocaleDateString("en-US");
    const end = new Date(endDate).toLocaleDateString("en-US");
    const generatedOn = new Date().toLocaleString();
    const generatedBy = auth?.name || "Aamar Dokan";
    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const reportTitle = "Profit & Loss Report";
  
    // Header Info
    const headerInfo = [
      `Store: ${storeName},,,,,,,,,,,,`,
      `Report: ${reportTitle},,,,,,,,,,,,Date Range: ${start} to ${end}`,
      `Generated On: ${generatedOn},,,,,,,,,,,,Generated By: ${generatedBy}`,
      "",
      "",
    ];
  
    // CSV Headers
    const csvTableHeader = [
      "S/N",
      "Invoice No",
      "Date",
      "Product ID",
      "Product Name",
      "TP",
      "MRP",
      "Qty",
      "Total Sell",
      "Total Cost",
      "Profit",
      "Profit %",
    ].join(",");
  
    // Totals
    let totalQty = 0;
    let totalSell = 0;
    let totalCost = 0;
    let totalProfit = 0;
  
    // Rows
    const csvRows = lossProfitData.map((item, index) => {
      const qty = Number(item.qty || 0);
      const sell = Number(item.totalSellAmount || 0);
      const cost = Number(item.totalCost || 0);
      const profit = Number(item.profit || 0);
  
      totalQty += qty;
      totalSell += sell;
      totalCost += cost;
      totalProfit += profit;
  
      return [
        index + 1,
        item.invoiceId || "",
        new Date(item.createdAt).toLocaleDateString("en-US"),
        item.productId || "",
        item.productName || "",
        item.tp?.toFixed(2) || "0.00",
        item.mrp?.toFixed(2) || "0.00",
        qty,
        sell.toFixed(2),
        cost.toFixed(2),
        profit.toFixed(2),
        item.profitPercent?.toFixed(2) || "0.00",
        // item.supplier || ""
      ].join(",");
    });
  
    // Summary Footer
    const summaryLabelRow = [",,,,,,,,,", "** SUMMARY **"].join(",");
    const summaryHeaderRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total Qty",
      "Total Sell",
      "Total Cost",
      "Total Profit",
      "",
      ""
    ].join(",");
  
    const summaryDataRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      totalQty,
      totalSell.toFixed(2),
      totalCost.toFixed(2),
      totalProfit.toFixed(2),
      "",
      ""
    ].join(",");
  
    // Combine
    const csvContent = [
      ...headerInfo,
      csvTableHeader,
      ...csvRows,
      "",
      "",
      summaryLabelRow,
      summaryHeaderRow,
      summaryDataRow
    ].join("\n");
  
    // Export logic
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ProfitLossReport.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  
  
    // export PDF
    const handleExportPDF = () => {
      if (!lossProfitData || lossProfitData?.length === 0) {
        alert("No data available for export.");
        return;
      }
    
      const doc = new jsPDF("landscape");
    
      const options = { month: "numeric", day: "numeric", year: "numeric" };
      const formattedStart = new Date(startDate).toLocaleDateString("en-US", options);
      const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
      const reportGeneratedAt = new Date().toLocaleString();
    
      const storeName = auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
      const reportName = "Profit & Loss Report";
    
      // Title
      doc.setFontSize(16);
      doc.text(storeName, 140, 15, { align: "center" });
    
      doc.setFontSize(12);
      doc.text(reportName, 140, 22, { align: "center" });
    
      // Header info
      doc.setFontSize(10);
      doc.text(`Store: ${storeName}`, 14, 28);
      doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 33);
      doc.text(`Generated At: ${reportGeneratedAt}`, 280, 28, { align: "right" });
      doc.text(`Generated By: ${auth?.name}`, 280, 33, { align: "right" });
    
      // Table headers
      const headers = [
        [
          "S/N",
          "Invoice ID",
          "Date",
          "Product",
          "TP",
          "MRP",
          "Qty",
          "Total Sale",
          "Total Cost",
          "Profit",
          "Profit %",
          // "Supplier"
        ]
      ];
    
      const data = lossProfitData.map((item, index) => [
        index + 1,
        item.invoiceId,
        new Date(item.createdAt).toLocaleDateString("en-US"),
        item.productName,
        Number(item.tp || 0).toFixed(2),
        Number(item.mrp || 0).toFixed(2),
        item.qty,
        Number(item.totalSellAmount || 0).toFixed(2),
        Number(item.totalCost || 0).toFixed(2),
        Number(item.profit || 0).toFixed(2),
        `${Number(item.profitPercent || 0).toFixed(2)}%`,
        // item.supplier || "N/A"
      ]);
    
      autoTable(doc, {
        head: headers,
        body: data,
        startY: 45,
        theme: "grid",
        styles: {
          fontSize: 9,
          halign: "center",
        },
        headStyles: {
          fillColor: [242, 101, 45], // tomato background
          textColor: [255, 255, 255], // white text
          fontStyle: "bold",
          lineWidth: 0.2, // line thickness
          lineColor: [255, 255, 255], // white border color
        },
      });
    
      // Summary Box
      const finalY = doc.lastAutoTable.finalY + 10;
      const lineHeight = 6;
      const boxHeight = 5 * lineHeight + 10;
      const boxWidth = 100;
      const pageWidth = doc.internal.pageSize.getWidth();
      const boxX = pageWidth - boxWidth - 15;
      const boxY = finalY;
    
      doc.setLineDashPattern([1, 1], 0);
      doc.rect(boxX, boxY, boxWidth, boxHeight);
      doc.setLineDashPattern([], 0);
    
      let y = boxY + 10;
      const labelX = boxX + 5;
      const valueX = boxX + boxWidth - 5;
      doc.setFontSize(9);
    
      const sumField = (arr, field) =>
        arr.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0);
    
      const totalSale = sumField(lossProfitData, "totalSellAmount");
      const totalCost = sumField(lossProfitData, "totalCost");
      const totalProfit = sumField(lossProfitData, "profit");
    
      doc.text("Total Sale Amount:", labelX, y);
      doc.text(`${totalSale.toFixed(2)}`, valueX, y, { align: "right" });
    
      y += lineHeight;
      doc.text("Total Cost Amount:", labelX, y);
      doc.text(`${totalCost.toFixed(2)}`, valueX, y, { align: "right" });
    
      y += lineHeight;
      doc.text("Total Profit:", labelX, y);
      doc.text(`${totalProfit.toFixed(2)}`, valueX, y, { align: "right" });
    
      y += lineHeight;
      const totalCostNum = parseFloat(totalCost) || 0;
      const avgProfitPercent =
        totalCostNum > 0 ? (totalProfit / totalCostNum) * 100 : 0;
      doc.text("Avg Profit %:", labelX, y);
      doc.text(`${avgProfitPercent.toFixed(2)}%`, valueX, y, { align: "right" });
    
      doc.save("ProfitLossReport.pdf");
    };

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> Profit and Loss Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className="d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
          className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        {/* Warehouse Dropdown */}
        {auth?.type === "admin" && (
          <div className="my-3">
            <WareHouseDW
              id="warehouse"
              name="warehouse"
              handleOnChange={handleOnchangeWareHouseFrom}
              className="form-control"
            />
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfitLossReport;
